import { Subscription } from '@eagle/core-data-types';
import { styled, TableBody, TableCell, TableHead, TableRow } from '@ethings/ui-toolkit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { T_ONE } from '../../constants';
import { testid } from '../../util';
import { SubscriptionsTableRow } from './subscriptions-table-row';
import { SubscriptionUserRecipientDataType } from './subscriptions.types';
import { COLUMN_WIDTH } from './subscriptions.util';

interface SubscriptionListDesktopViewProps {
  disableLink?: boolean;
  isLoading: boolean;
  subscriptions: Subscription[];
  subscriptionDetailPath: string;
  userRecipientDataType: SubscriptionUserRecipientDataType;
}

interface StyledTableBodyProps {
  isLoading: boolean;
}

const StyledTableBody = styled(TableBody, {
  shouldForwardProp: (prop) => prop !== 'isLoading',
})<StyledTableBodyProps>(({ isLoading }) => ({
  filter: isLoading ? 'blur(1px)' : '',
  opacity: isLoading ? 0.66 : 1,
}));

const StyledTableCell = styled(TableCell)();

export const SubscriptionListDesktopView: FC<SubscriptionListDesktopViewProps> = ({ subscriptions, isLoading, disableLink, subscriptionDetailPath, userRecipientDataType }) => {
  const { t } = useTranslation();

  return (
    <>
      <TableHead component="div">
        <TableRow component="div">
          <StyledTableCell component="div" sx={{ width: COLUMN_WIDTH }}>{t('common:terms.recipient', { count: T_ONE })}</StyledTableCell>
          <StyledTableCell component="div" sx={{ width: COLUMN_WIDTH }}>{t('common:terms.from')}</StyledTableCell>
          <StyledTableCell component="div" sx={{ width: COLUMN_WIDTH }}>{t('common:terms.feature')}</StyledTableCell>
          <StyledTableCell component="div" sx={{ width: COLUMN_WIDTH }}>{t('common:terms.alert', { count: T_ONE })}</StyledTableCell>
        </TableRow>
      </TableHead>
      <StyledTableBody component="div" isLoading={isLoading}>
        {subscriptions.map((item, i) => <SubscriptionsTableRow key={i} userRecipientDataType={userRecipientDataType} subscription={item} subscriptionDetailPath={subscriptionDetailPath} disableLink={disableLink} data-testid={testid`subscription-list-item-${i}`} />)}
      </StyledTableBody>
    </>
  );
};
